import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "@app/shared";
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import {
  SalesSkillsAddEditComponent, SalesSkillsComponent
} from "@modules/others//configuration/components/skill-general";

const routes: Routes = [
  {
    path: "skills",
    children: [
      {
        path: "",
        component: SalesSkillsComponent,
        data: { title: "Skills List" }, canActivate: [AuthGuard]
      },
      {
        path: "add-edit",
        component: SalesSkillsAddEditComponent,
        data: { title: "Skill Add Edit" }, canActivate: [AuthGuard]
      }
    ]
  }
];
@NgModule({
  declarations: [SalesSkillsComponent, SalesSkillsAddEditComponent],
  imports: [
    MaterialModule,
    SharedModule,
    RouterModule.forChild(routes)
  ]
})
export class SkillGeneralModule { }
